import React from 'react';
import { BlockComponentProps } from 'client-react-block-renderer/src';
import downloadjs from 'downloadjs';
import { gtag } from 'google-analytics';

interface Props extends BlockComponentProps<Data, Config> { }

interface Config {
    src: string;
    alt: string;
    downloadUrl: string;
    label: string;
}

interface Data {
}

const DownloadableImageContainer = (props: Props) => {
    const downloadUrl = (
        props.config.downloadUrl.trim().length !== 0 ? props.config.downloadUrl
            : props.config.src
    );
    const download = (e) => {
        e.preventDefault();
        /**
         * "corsHeaderCacheBreaker" prevents the response headers from being
         *  cached without CORS info from when the image was first displayed.
         */
        downloadjs(downloadUrl + '?corsHeaderCacheBreaker=' + new Date().getTime());
        /**
         * @todo 2021-04-23 - bharms@relivinc.com - axosoft/25604:
         *       If the download above is being fetched from our own servers,
         *       it would be ideal if the endpoint for that fired the analytics
         *       event below instead of performing it client-side. Otherwise,
         *       just ensure that the analytics session ID from the server is
         *       also used for the event being fired here.
         */
        gtag('event', 'rcmDownloadableImageBlockDownload', {
            event_label: downloadUrl,
        });
    };
    return <div className="blockDownloadableImage">
        {props.config.label && props.config.label.trim().length !== 0 &&
            <div className="blockDownloadableImageLabel">
                {props.config.label}
            </div>
        }
        <a href={downloadUrl} onClick={download}>
            <img src={props.config.src} alt={props.config.alt} />
        </a>
    </div>;
};

export default DownloadableImageContainer;
